import { useAuthStore } from '@/store/auth'
import { QueryStringKeys } from '@/constants/commons'

export default defineNuxtPlugin({
  parallel: true,
  setup: nuxtApp => {
    const authStore = useAuthStore()
    const route = useRoute()

    const removePageFinishHook = nuxtApp.hook('page:finish', () => {
      if (route.query[QueryStringKeys.REDIRECT_URL] && !authStore.isLogin && !authStore.isLoginModalShown) {
        requestAnimationFrame(authStore.openLoginModal)
      }
      removePageFinishHook()
    })
  },
})
